
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addRating, getAllReviews } from "../../features/product/productThunks";
import "./addReview.css";
import { Link } from "react-router-dom";

const AddReview = ({ productId }) => {
    const dispatch = useDispatch();
    const [showForm, setShowForm] = useState(false);
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [comment, setComment] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(addRating({ productId, ratingForm: { rating, comment } }))
            .unwrap()
            .then(() => {
                setRating(0);
                setComment("");
                setShowForm(false);
                dispatch(getAllReviews(productId));
            });
    };

    return (
        <div>
            {!showForm ? (
                <button className="add-review-btn" onClick={() => setShowForm(true)}>
                    Write a Review
                </button>
            ) : (
                <div
                    className="add-review-overlay"
                    onClick={() => setShowForm(false)}
                >
                    <form
                        onSubmit={handleSubmit}
                        className="add-review-form"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="close-btn"
                            onClick={() => setShowForm(false)}
                        >
                            ❌
                        </button>

                        <div className="star-rating">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    className={`star ${star <= (hover || rating) ? "filled" : ""}`}
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHover(star)}
                                    onMouseLeave={() => setHover(0)}
                                >
                                    ★
                                </span>
                            ))}
                        </div>

                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Write your comment here..."
                            required
                        />
                        <Link to="/coming-soon">
                            <button type="submit" className="submit-btn">
                                Submit Review
                            </button>
                        </Link>
                    </form>
                </div>
            )}
        </div>
    );
};

export default AddReview;
